/**
 * @generated SignedSource<<ab8c78dbca93c8c90c7eaf6038fc23f3>>
 * @relayHash 4843fe4d8b06427be53fd4aa7a21171a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { contextFields_projectDataQuery } from './contextFields_projectDataQuery.graphql';

const node: PreloadableConcreteRequest<contextFields_projectDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e",
    "metadata": {},
    "name": "contextFields_projectDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
